export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Diese Aktion wird das Asset dauerhaft löschen"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sind Sie sicher, dass Sie fortfahren möchten?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ja"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sie werden dieses Asset nicht mehr in Ihrer Liste sehen."])}
}